import React, {useContext} from 'react';
import {ViewContext} from './contexts/ViewContext';
import {Doughnut} from 'react-chartjs-2';
import {colors} from './utils/MapStyles';
import {Grid, Card, CardHeader, CardContent, CardActions, Button} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	card: {
		padding: theme.spacing(3),
	},
}));
export default function Chart(props) {
	const {view, dispatch} = useContext(ViewContext);

	const classes = useStyles();
	const {title, data, labels, type, backgroundColor, subheader, seeOnMap} = props.chartdata;

	return (
		<Grid item xs={12} md={6}>
			<Card className={classes.card}>
				<CardHeader title={title} subheader={subheader} />
				<CardContent>
					<Doughnut
						data={{
							labels: labels,
							datasets: [
								{
									label: title,
									data: data,
									backgroundColor: backgroundColor,
									hoverOffset: 4,
								},
							],
						}}
					/>
				</CardContent>
				<CardActions>
					<Button
						size="small"
						color="primary"
						onClick={() =>
							dispatch({
								type: 'CHANGE VIEW',
								view: 'Map',
								mapView: seeOnMap && seeOnMap.mapView ? seeOnMap.mapView : null,
								mapFilterIndices:
									seeOnMap && seeOnMap.mapFilterIndices ? seeOnMap.mapFilterIndices : null,
								mapFilterProps: seeOnMap && seeOnMap.mapFilterProps ? seeOnMap.mapFilterProps : null,
							})
						}
					>
						See on the map
					</Button>
				</CardActions>
			</Card>
		</Grid>
	);
}
